import {
  ACTIVATION_ACCOUNT,
  SAVE_ACCOUNT_ID,
  SAVE_PHONE_NUMBER,
  SAVE_LICENSE_PLATE,
  SAVE_BALANCE_ACCOUNT,
  SAVE_ACCOUNT_SETTINGS,
  SAVE_ACCOUNT_SETTINGS_PROGRESS,
  SAVE_ACCOUNT_SETTINGS2,
  SAVE_ACCOUNT_SETTINGS2_FAILER,
  SHOW_ACCOUNT_INFO
} from './../constants/actionTypes';

const initialState = {
  needActivation: false,
  accountId: '',
  licensePlate: '',
  balance: '',
  showAccountInfo: false,
  phoneNumber: '',
  email: '',
  password: '',
  showIndicator: false
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case ACTIVATION_ACCOUNT:
      return {
        ...state,
        needActivation: action.needActivation
      };

    case SAVE_ACCOUNT_ID:
      return{
        ...state,
        accountId: action.accountId
      };

    case SAVE_BALANCE_ACCOUNT:
      return{
        ...state,
        balance: action.balance
      };

      case SAVE_ACCOUNT_SETTINGS:
        return{
          ...state,
          phoneNumber: action.phoneNumber,
          email: action.email,
          licensePlate: action.licensePlate,
          password: action.password
        };

        case SAVE_ACCOUNT_SETTINGS2:
          return{
            ...state,
            email: action.email,
            licensePlate: action.licensePlate,
            password: action.password,
            isProgressSaveSettings: false
          };

        case SAVE_ACCOUNT_SETTINGS2_FAILER:
          return {
            ...state,
            isProgressSaveSettings: false
          };

        case SAVE_ACCOUNT_SETTINGS_PROGRESS:
           return {
             ...state,
             isProgressSaveSettings: true
           };

        case "SHOW_LOADING_INDICATOR":
           return {
            ...state,
            showIndicator: action.showIndicator
          };


    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/authReducer.js